import React, { FC } from 'react';
import { components } from './data';

export const About: FC = () => {
  return (
    <main>
      {components.map(({ name, props }, index) => {
        const C = name;
        /* @ts-expect-error: key type is never*/
        return <C {...props} key={`component-${index}`} />;
      })}
    </main>
  );
};
